<template>
	<div class="color_header" :class="radius?'radius':''">
		<div v-if="showback" class="back_btn" @click.stop="handleBack">
			<van-icon :name="backicon" size="25" color="#ffffff"/>
		</div>
		<div class="color_header_title"  :class="istitle?'istitle':''">{{title}}</div>
		<div v-if="kefu" class="kefu" @click="$router.push('/kefu')">
			<van-icon name="service" size="30" color="#ffffff"/>
		</div>
		<div class="language" @click="$router.push('/language')">
			<img :src="require('../views/images/language/' + lang + '.png')" />
		</div>
	</div>
</template>
<script>
	export default {
		name: "colorHeader",
		props: {
			istitle:{
				type:[Boolean],
				default:false
			},
			showback:{
				type:[Boolean],
				default:true
			},
			radius:{
				type:[Boolean],
				default:true
			},
			backicon:{
				type:[String],
				default:'arrow-left'
			},
			backurl: {
				type: [String, Number],
				default: -1
			},
			title: {
				type: [String],
				default: ""
			},
			kefu: {
				type: [Boolean],
				default: false
			},
		},
		data(){
			return{
				lang: this.$i18n.locale || "zh_cn",
			}
		},
		methods: {
			handleBack(e) {
				console.log(this.backurl);
				if (this.backurl != -1) {
					this.$router.push({
						path: this.backurl
					});
					return;
				}
				if (window.history.length > 1) {
					this.$router.go(-1)
				} else {
					this.$router.push({
						path: "index"
					})
				}

			},
			right_router(e) {
				console.log(this.routerurl)
				if (this.routerurl != -1) {
					this.$router.push({
						path: this.routerurl
					});
					return;
				}
			}
		},
	}
</script>
<style lang="less" scoped>
.color_header {
	
  position: fixed;
  top: 0;
  z-index: 100;
  height: 64px;
  line-height: 64px;
  width: 100%;
  max-width: 750px;
	background: -webkit-linear-gradient(left,#00e6ff,#6439e1);
	background: linear-gradient(90deg,#00e6ff,#6439e1);
	&.radius{
		border-bottom-left-radius:10px;
		border-bottom-right-radius:10px;
	}
  .language {
    position: absolute;
    top: 12px;
    right: 12px;
    height: 40px;
    img {
      height: 100%;
    }
  }
  .kefu{
	  position: absolute;
		top: 8px;
		right: 56px;
		height: 40px;
		width: 40px;
  }
  .back_btn {
    position: absolute;
    top: 4px;
    left: 12px;
    height: 23px;
  }
  .color_header_title {
    text-align: center;
    font-size: 18px;
    display: block;
    height: 64px;
    line-height: 64px;
	color: #ffffff;
	&.istitle{
		text-align: left;
		text-indent: 40px;
	}
  }
}
</style>
